import { useLocation } from 'react-router-dom';
import { ErrorBoundary } from './ErrorBoundary';

export const ErrorBoundaryHoc: React.FC = ({ children }) => {
  const location = useLocation();
  return <ErrorBoundary location={location}>{children}</ErrorBoundary>;
};
